// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"ceea5b3c676f8e96","9102":"a625fe9b829ad489"}[chunkId] + ".css";
};